import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";
import { systemAllRequests } from "../utilities/utils";

export const _fetchUnfilledContracts = async (data) => {
  let search = data.search;
  let currentPage = data.currentPage;

  let actionedById = data.actionedById;
  let actionedByType = data.actionedByType;
  let contractRefNo = data.contractReferenceNo;
  let roleId = data.roleId;
  let createdDateFrom = data.createdDateFrom;
  let createdDateTo = data.createdDateTo;
  let shiftDateFrom = data.shiftDateFrom;
  let shiftDateTo = data.shiftDateTo;
  let sortByColumn = data.sortByColumn;
  let sortByOrder = data.sortByOrder;
  let ContractStatus = data.contractStatus;

  if (roleId && (roleId !== "" || roleId.length > 0)) {
    roleId = roleId.join(",");
  }

  if (createdDateFrom && createdDateFrom !== "") {
    createdDateFrom = createdDateFrom.split("/").reverse().join("-");
  }

  if (createdDateTo && createdDateTo !== "") {
    createdDateTo = createdDateTo.split("/").reverse().join("-");
  }

  if (shiftDateFrom && shiftDateFrom !== "") {
    shiftDateFrom = shiftDateFrom.split("/").reverse().join("-");
  }

  if (shiftDateTo && shiftDateTo !== "") {
    shiftDateTo = shiftDateTo.split("/").reverse().join("-");
  }

  let postData = {
    search,
    page: currentPage,
    actioned_by_id: actionedById,
    actioned_by_type: actionedByType,
    contract_reference_no: contractRefNo,
    role_id: roleId,
    created_date_from: createdDateFrom,
    created_date_to: createdDateTo,
    shift_date_from: shiftDateFrom,
    shift_date_to: shiftDateTo,
    contract_status: ContractStatus,
    sortByColumn,
    sortByOrder,
  };

  systemAllRequests({
    request: postData,
    pageOfRequest: "unfilled",
    crmRoute: "get_unfilled_contract_list",
    method: "POST",
    page: "unfilled",
  });
  const request = {
    endPoint: serviceRouteConstants?.unfilledContracts,
    data: postData,
  };
  return await post(request);
};

// export const _updateContractToAppLocum = async (data) => {
//     const request = {
//         endPoint: serviceRouteConstants?.unfilledPublishContractForAppLocum,
//         data: data,
//     };
//     return await post(request);
// };

export const _deleteUnfilledContracts = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.unfilledDeleteContracts,
    data: data,
  };
  return await post(request);
};

// Get manage shift calander data...
export const _unfilledManageGetShiftCalander = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.unfilledGetShiftCalander,
    data: data,
  };
  return await post(request);
};

// unfilledEditManageShiftsContract

export const _unfilledEditManageShiftsContract = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.unfilledGetEditManageShiftsContract,
    data: data,
  };
  return await post(request);
};

export const _unfilledUpdateManageShiftsContract = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.unfilledUpdateEditManageShiftsContract,
    data: data,
  };
  return await post(request);
};

export const _unfilledDeleteManageShiftsContract = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.unfilledDeletemanageShiftContract,
    data: data,
  };
  return await post(request);
};

export const _unfilledGetAddManageShiftsContract = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.unfilledGetAddShiftDetails,
    data: data,
  };
  return await post(request);
};

export const _unfilledAddNewManageShiftsContract = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.unfilledAddNewManageShiftsContract,
    data: data,
  };
  return await post(request);
};

export const _unfilledProposedShiftsContract = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.unfilledProposeCandiateForContract,
    data: data,
  };
  return await post(request);
};

export const _checkJobCretariaForCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.checkJobCretariaForCandidate,
    data: data,
  };
  return await post(request);
};
